import hasFeature from 'modules/core/lib/hasFeature'

import useIsAccessInAutoApprovalGroup from 'modules/approvals/hooks/useIsAccessInAutoApprovalGroup'

export const useHasToRequestUpdate = () => {
  const { loading, isAutoApprover } = useIsAccessInAutoApprovalGroup({ category: 'contracts' })
  const hasApprovalSystem = hasFeature('dev_update_flow_approval_system')
  return {
    loading: hasApprovalSystem ? loading : false,
    hasToRequestUpdate: hasApprovalSystem ? !isAutoApprover : false,
  }
}
